
<div class="container">
    <h2 class="section-title card-title">Media Mentions<span class="wow"></span></h2>
    <div id="blockquoteCarousel" class="tab-dots carousel slide pointer-event" data-ride="carousel" data-interval="4000">
        <a class="carousel-control-prev" href="#blockquoteCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#blockquoteCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
        <div class="carousel-inner">
            <ng-container *ngFor="let item of mentions;let i = index">
            <div [ngClass]="i===0 ? 'carousel-item active' : 'carousel-item'">
                <div class="blockquote-caption">
                    <img [src]="item.icon_image" alt="">
                    <blockquote>
                        <span [innerHTML]="item.description"></span>
                    </blockquote>
                </div>
            </div>
        </ng-container>
           
        </div> 
                                
        <ol class="carousel-indicators">
        <ng-container *ngFor="let dot of mentions;let j = index">
            <li data-target="#blockquoteCarousel" [attr.data-slide-to]="j" ></li>
        </ng-container>
            <!-- <li data-target="#blockquoteCarousel" data-slide-to="1"></li>
            <li data-target="#blockquoteCarousel" data-slide-to="2"></li> -->
        </ol>
   
    </div>
</div>

